import { render } from "./etaxHomeIndex.vue?vue&type=template&id=c8a53b5a&scoped=true"
import script from "./etaxHomeIndex.vue?vue&type=script&lang=js"
export * from "./etaxHomeIndex.vue?vue&type=script&lang=js"

import "./etaxHomeIndex.vue?vue&type=style&index=0&id=c8a53b5a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a53b5a"]])

export default __exports__